import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    LoadRealTimeInventory,
    chain,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { CatalogPage } from "@insite/client-framework/Services/CategoryService";
import {
    GetProductCollectionApiV2Parameter,
    ProductExpandTokens,
} from "@insite/client-framework/Services/ProductServiceV2";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}

export interface DisplayProductsResult {
    products?: ProductModel[];
    productInfosByProductId: SafeDictionary<ProductInfo>;
    productFilters: ProductFilters;
    isFiltered: boolean;
    unfilteredApiParameter?: GetProductCollectionApiV2Parameter;
    filteredApiParameter?: GetProductCollectionApiV2Parameter;
    catalogPage?: CatalogPage;
}

interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}

type HandlerType = Handler<Parameter, Props>;

export const CustomLoadRealTimeInventory: HandlerType = props => {
    const state = props.getState();
    if (!state.context.session.isAuthenticated || true) {
        return;
    }
    // if (!props.result.products?.length || getIsWebCrawler()) {
    //     return;
    // }

    // props.dispatch(
    //     loadRealTimeInventory({
    //         productIds: props.result.products.map(o => o.id),
    //         onSuccess: realTimeInventory => {
    //             props.dispatch({
    //                 type: "Pages/ProductList/CompleteLoadRealTimeInventory",
    //                 realTimeInventory,
    //             });
    //         },
    //         onError: () => {
    //             props.dispatch({
    //                 type: "Pages/ProductList/FailedLoadRealTimeInventory",
    //             });
    //         },
    //         onComplete(realTimeInventoryProps) {
    //             if (realTimeInventoryProps.apiResult) {
    //                 this.onSuccess?.(realTimeInventoryProps.apiResult);
    //             } else if (realTimeInventoryProps.error) {
    //                 this.onError?.(realTimeInventoryProps.error);
    //             }
    //         },
    //     }),
    // );
};

replaceInChain(chain, LoadRealTimeInventory, CustomLoadRealTimeInventory);
